import React,{useState} from 'react'
import ExamImage from "../assets/images/exam.svg";
import {toPersianNumber} from "../utils/numberConversion";
import {toast} from "react-toastify";
import {api} from "../utils/gashtaltAPI";
import {DatePicker} from "zaman";
function AdminExamCard({exam, onClickCard,onDeleteClick,navigator, newExam = false,NewExamTitle='آزمون جدید'}) {
    const [active,setActive] = useState(exam ? exam.status===1 : false)
    const handleClick = async () => {
        try {
            const response = await api.post("/api/exam/status/update",{
                exam_id : exam?.id
            });
            setActive(response.data.status)
            toast.success(response.data.message, {
                position: "bottom-right"
            });
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status !== 500) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            console.log(error)
            toast.error("خطایی رخ داد!", {
                position: "bottom-right"
            });
        }
    }
    if (newExam) {
        return (<div className="col-lg-3 col-11 p-2">
            <div className="admin-exam-card">
                <div className="d-flex flex-row align-items-center px-4">
                    <h5 className={'exam-card-title'}>{NewExamTitle}</h5>
                </div>
                <button className="btn btn-filled col-10 my-5" onClick={onClickCard}>ساخت {NewExamTitle}</button>
            </div>
        </div>);
    }
    return (<div className="col-lg-3 col-11 p-2">
        <div className="admin-exam-card">
            <div className="d-flex flex-row align-items-center px-4">
                <h5 className={'exam-card-title'}>{exam.name}</h5>
                <button className={`btn ${!active ? 'btn-outline-red' : 'btn-outline-blue'}`} onClick={handleClick} style={{padding:'.25rem .5rem',fontSize:'.9rem'}}>
                    {!active ? 'غیرفعال' : 'فعال'}
                </button>
            </div>
            <div className="d-flex flex-column align-items-start px-5">
                <p>
                    قیمت :

                    <span>{exam.price === 0 ? 'رایگان' : toPersianNumber(exam.price) + ' تومان '}</span>
                </p>
                <p>
                    زمان :
                    <span>{toPersianNumber(exam.duration)}</span>
                    دقیقه
                </p>
            </div>
            <div className="d-flex flex-row justify-content-around py-2">
                <button className="btn btn-outline-red" onClick={onDeleteClick}>حذف ازمون</button>
                <button className="btn btn-outline-blue " onClick={onClickCard}>ویرایش</button>
                <button className="btn btn-outline-green" onClick={()=>{navigator(`/exam/${exam.id}`);}}>سوالات</button>
            </div>
        </div>
    </div>);
}

export default AdminExamCard;
